import { Card, Elevation } from "@blueprintjs/core";
import queryString from 'query-string';
import React from 'react';
import { Link, withRouter } from 'react-router-dom';

class Payment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      loaded: false,
      preview: true,
      paySuccess: false,
      partyDetails: false,
      complete: false,
      pay: false,
      locations: [],
      selectedLocation: {},
      data: {},
      values: {
        owner: {},
        tenant: {}
      }
    }
  }

  componentDidMount() {

  }

  rightContent = () => {
    let parsedQs = queryString.parse(this.props.location.search);
    if (this.props.match.params.status === "success") {
      return (
        <Card className="card" elevation={Elevation.ONE}>
          <div className="has-text-centered is-size-6">
            <p className="has-text-success has-text-weight-semibold is-size-5">Payment Successful!</p>
            <p>You have successfully made payment for online rent agreement.</p>
            <p>Continue to fill the details for Tenant and Owner.</p>
          </div>
          <Link
            to={`/rentagreement/details/${parsedQs.Uid}`}
            className="bp3-intent-primary bp3-button bp3-fill bp3-large"
            style={{ marginTop: "2rem" }}
          >Continue</Link>
        </Card>
      )
    } else if (this.props.match.params.status === "failed") {
      return (
        <Card className="card" elevation={Elevation.ONE}>
          <div className="has-text-centered is-size-6">
            <p className="has-text-danger has-text-weight-semibold is-size-5">Something went wrong!</p>
            <p>The payment for your rent agreement was not successfull.</p>
            <p>Contact our representative for more details.</p>
          </div>
          <Link
            to={`/rentagreement/details/${parsedQs.Uid}`}
            className="bp3-intent-danger bp3-button bp3-fill bp3-large"
            style={{ marginTop: "2rem" }}
          >Continue</Link>
        </Card>
      )
    }
  }

  render() {
    return (
      <section className="section">
        <div className="container">
          <div className="w-420">
            {this.rightContent()}
          </div>
        </div>
      </section>
    );
  }
}

export default withRouter(Payment);


// WEBPACK FOOTER //
// ./src/app/components/payment/index.js